import type { Chat } from './api/types';

/** Andi is still talking with the builder: the chat hasn't ended or been handed to the team. */
export const isLive = (chat: Chat) => chat.status === 'active';

/** The chat can take no more messages: a build was requested, or the chat used up its turns. */
export const isLocked = (chat: Chat) => chat.status === 'locked' || chat.status === 'exhausted';

/** Something was said after Andi's last reply (a message, or a choice, saved as a "Clarified" event) and no
 *  reply follows it yet. */
export function isUnanswered(chat: Chat): boolean {
  const last = chat.messages?.at(-1);
  return Boolean(last) && last?.role !== 'agent';
}

/** A reply is being written: the server holds the chat's lease, or couldn't say and a question is open. */
export function isReplyInFlight(chat: Chat): boolean {
  if (!isLive(chat)) return false;
  const state = chat.turn?.state ?? 'unknown';
  return state === 'running' || (state === 'unknown' && isUnanswered(chat));
}

/** The last question was never answered and nothing is working on it: its reply was interrupted. */
export function isReplyInterrupted(chat: Chat): boolean {
  const state = chat.turn?.state;
  return isLive(chat) && isUnanswered(chat) && (state === 'interrupted' || state === 'idle');
}
